const Messages = [
    {
        MessageType: 'sharetext',
        Language: 1,
        MessageText1: 'Arkadaşınızın da',
        MessageText2: 'dijital kartını yükleyebilmesi için aşağıdaki QR kodu telefon kamerası veya QR Taratıcısı ile okutması yeterlidir.',
         ButtonText: 'Kopyala',
    },
    {
        MessageType: 'sharetext',
        Language: 2,
        MessageText1: 'If your friend wants to have ',
        MessageText2: 'digital card too, he/she should scan The Qr Code below with a mobile phone camera or a QR Scanner.',
         ButtonText: 'Copy',
    },
    {
        MessageType: 'sharetext',
        Language: 3,
        MessageText1: 'Если хотите, чтобы у вашего друга тоже была диджитал-карта ',
        MessageText2: 'то, пожалуйста, скопируйте QR-код и поделитесь им или ссылкой ниже. Обратите внимание, переход по ссылке и QR-коду возможны только с мобильного телефона.',
        ButtonText: 'Копировать',
    },
    {
        MessageType: 'sharetext',
        Language: 4,
        MessageText1: ' عن طريق مسح الباركود المتواجد في الاسفل',
        MessageText2: 'الآن بامكان اصدقاؤك الاشتراك في بطاقة',
        ButtonText: 'ينسخ',

    },
    {
        MessageType: 'systemerror',
        Language: 1,
        Caption: 'Beklenmedik bir hata oluştu!'
    },
    {
        MessageType: 'systemerror',
        Language: 2,
        Caption: 'An unexpected error occured!'
    },
    {
        MessageType: 'systemerror',
        Language: 3,
        Caption: 'Произошла непредвиденная ошибка!'
    },
    {
        MessageType: 'systemerror',
        Language: 4,
        Caption: 'حدث خطأ غير متوقع!'
    }
];

export function getLocalizedMessage(messagetype, language) {
    return Messages.filter(m => m.MessageType === messagetype && m.Language === language)[0];
}
